import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../layout/components/Header";
import TenantLogo from "../layout/components/TenantLogo";
import BookLocationHeader from "../bookLocation/common/util/BookLocationHeader";
import { LocationSelectionProvider } from "./context/LocationSelectionContext";
import { LocationSelectionContent } from "./components/LocationSelectionContent";

/**
 * LocationSelectionPage Component
 * ---------------------------------------------------------------
 * Main page for location selection flow.
 *
 * @remarks
 * This page provides:
 * - Location listing and selection
 * - Equipment/service listing for selected location
 * - URL-based state persistence
 * - TanStack Query for data fetching (replacing Redux)
 *
 * @example
 * Route: /location-selection?locationId=loc-123
 */
export default function LocationSelectionPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center">
      <Header>
        <TenantLogo />
      </Header>
      <div className="mb-6">
        <BookLocationHeader text={t("book_location.select_location")} />
      </div>
      <LocationSelectionProvider>
        <LocationSelectionContent />
      </LocationSelectionProvider>
    </div>
  );
}
